import React, { useEffect, useState } from 'react';
import {
  Alert,
  Collapse,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { ILegalTransaction_has_LegalTransactionSpecialFunction } from '../../../Interfaces/ILegalTransaction_has_LegalTransactionSpecialFunction';
import { ChangeLegalPhaseCondition } from '../ChangeLegalPhaseCondition';
import { ILegalPhaseFullObject } from '../../../Interfaces/ILegalPhase';
import { ILegalRequirementState } from '../../../Interfaces/ILegalRequirementState';
import { CustomeTextField } from '../../../generic/CustomeTextField';
import { useSelector } from 'react-redux';
import { State } from '../../../redux/mainReducer';
import { useGetFederalStateLogins } from '../../../hooks/reactQuerys/FederalStateLoginQueries';
import { useFederalStates } from '../../../Aemter/hooks';
import { useGetUsers } from '../../../hooks/data';

interface IProps {
  idLegalTransaction: number;
  currentSpecialFunction: ILegalTransaction_has_LegalTransactionSpecialFunction;
  legalTransaction_has_LegalTransactionSpecialFunctionArray: ILegalTransaction_has_LegalTransactionSpecialFunction[];
  setLegalTransaction_has_LegalTransactionSpecialFunctionArray: Function;
  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
  legalReqState: ILegalRequirementState[];
  deleteSpecialFunction: Function;
}

interface IPayload {
  date: string;
  idDistrictCourt: null | number;
  idLandMarking: null | number;
  Court: string;
  Marking: string;
  idFederalStateLogin: number;
  Sheet: string;
}

export const LandRegisterCheckEntry = ({
  idLegalTransaction,
  currentSpecialFunction,
  legalTransaction_has_LegalTransactionSpecialFunctionArray,
  setLegalTransaction_has_LegalTransactionSpecialFunctionArray,
  legalPhaseFullObjectArray,
  legalReqState,
  deleteSpecialFunction,
}: IProps) => {
  const districtCourtArray = useSelector(
    (state: State) => state.districtCourtArray.storeDistrictCourt
  );
  const landMarkingArray = useSelector(
    (state: State) => state.landMarkingArray.storeLandMarking
  );
  const { federalStateLogins, isFederalStateLogins } =
    useGetFederalStateLogins();
  const { federalStates, isLoadingFederalStates } = useFederalStates();
  const { users, isLoadingUsers } = useGetUsers();

  const districtCourt = districtCourtArray.find(
    dc => dc.Court === currentSpecialFunction.Function_Field4
  );
  const landMarking = landMarkingArray.find(
    lm => lm.LandMarking === currentSpecialFunction.Function_Field5
  );
  const currentLogin =
    currentSpecialFunction.Function_Field6 === ''
      ? undefined
      : federalStateLogins?.find(
          login =>
            login.idFederalStateLogin ===
            Number(currentSpecialFunction.Function_Field5)
        );

  const [payload, setPayload] = useState<IPayload>({
    date: currentSpecialFunction.Function_Field1,
    idDistrictCourt:
      districtCourt === undefined ? null : districtCourt.idDistrictCourt,
    Court: currentSpecialFunction.Function_Field4,
    idLandMarking: landMarking === undefined ? null : landMarking.idLandMarking,
    Marking: currentSpecialFunction.Function_Field5,
    idFederalStateLogin:
      currentSpecialFunction.Function_Field6 === ''
        ? -1
        : Number(currentSpecialFunction.Function_Field6),
    Sheet: currentSpecialFunction.Function_Field2,
  });

  // Hilfsvarbiablen für Zugangssuche
  const [idFedearalState, setIdFedearalState] = useState(-1);
  const [idNotaryUser, setIdNotaryUser] = useState(-1);

  useEffect(() => {
    if (
      federalStateLogins !== undefined &&
      payload.idFederalStateLogin > 0 &&
      idFedearalState === -1 &&
      idNotaryUser === -1
    ) {
      const testLogin = federalStateLogins.find(
        login => login.idFederalStateLogin === payload.idFederalStateLogin
      );

      if (testLogin) {
        setIdFedearalState(testLogin.idFederalState);
        setIdNotaryUser(testLogin.Notary_idUser);
      }
    }
  }, [federalStateLogins]);

  useEffect(() => {
    const uplodatedObject: ILegalTransaction_has_LegalTransactionSpecialFunction =
      {
        ...currentSpecialFunction,
        Function_Field1: payload.date,
        Function_Field2: payload.Sheet,
        //Function_Field3: currentSpecialFunction.Function_Field3,
        Function_Field4: payload.Court,
        Function_Field5: payload.Marking,
        Function_Field6: String(payload.idFederalStateLogin),
      };

    setLegalTransaction_has_LegalTransactionSpecialFunctionArray([
      ...legalTransaction_has_LegalTransactionSpecialFunctionArray.map(
        specialFunction =>
          specialFunction.idLegalTransaction_has_LegalTransactionSpecialFunction ===
          uplodatedObject.idLegalTransaction_has_LegalTransactionSpecialFunction
            ? uplodatedObject
            : specialFunction
      ),
    ]);
  }, [payload]);

  return (
    <React.Fragment
      key={
        currentSpecialFunction.idLegalTransaction_has_LegalTransactionSpecialFunction
      }
    >
      {currentSpecialFunction.Function_Field3 === '0' && (
        <Grid item sm={12}>
          <Alert severity='warning'>Keine Nachverfolgung aktiviert</Alert>
        </Grid>
      )}
      {currentSpecialFunction.Function_Field3 === '1' && (
        <Grid item sm={12}>
          <Alert severity='info'>
            Nachverfolgung aktiviert, noch nicht eingetragen
          </Alert>
        </Grid>
      )}
      {currentSpecialFunction.Function_Field3 === '2' && (
        <Grid item sm={12}>
          <Alert severity='success'>Eintragung erfolgt</Alert>
        </Grid>
      )}

      <Grid item sm={2}>
        <CustomeTextField
          label='Datum'
          attr='date'
          object={payload} // Blattnummer aus currentSpecialFunction.Function_Field2 initialisieren
          required
          type='date'
          null
          setObject={setPayload}
        />
      </Grid>

      <Grid item xs={9}>
        <CustomeTextField
          label='Blattnummer'
          attr='Sheet'
          object={payload} // Blattnummer aus currentSpecialFunction.Function_Field2 initialisieren
          required
          type='string'
          null
          setObject={setPayload}
        />
      </Grid>

      <Grid item sm={1}>
        <IconButton
          onClick={() =>
            deleteSpecialFunction(
              currentSpecialFunction.idLegalTransaction_has_LegalTransactionSpecialFunction
            )
          }
        >
          <Delete />
        </IconButton>
      </Grid>

      <Grid item xs={3}>
        <TextField
          //type="email"
          variant='outlined'
          label='Bundesland'
          fullWidth
          value={idFedearalState < 0 ? '' : idFedearalState}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setIdFedearalState(Number(event.target.value));
            setPayload({
              ...payload,
              idFederalStateLogin: -1,
            });
          }}
          required
          select
          size='small'
        >
          {(federalStates || [])
            .filter(federalState => federalState.isEnabledSolumWeb == true)
            .map(federalState => (
              <MenuItem
                key={`federalSTate-${federalState.idFederalState}`}
                value={federalState.idFederalState}
              >
                {`${federalState.FederalState}`}
              </MenuItem>
            ))}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        <Collapse in={idFedearalState > 0}>
          <TextField
            //type="email"
            variant='outlined'
            label='Notar'
            fullWidth
            value={idNotaryUser < 0 ? '' : idNotaryUser}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setIdNotaryUser(Number(event.target.value));
              setPayload({
                ...payload,
                idFederalStateLogin: -1,
              });
            }}
            required
            select
            size='small'
          >
            {users!
              .filter(user => user.isNotary == true)
              .filter(
                user =>
                  (federalStateLogins || [])
                    .filter(login => login.idFederalState === idFedearalState)
                    .filter(login => login.Notary_idUser === user.idUser)
                    .length > 0
              )
              .map(user => (
                <MenuItem
                  key={`select-user-${user.idUser}`}
                  value={user.idUser}
                >
                  {`${user.FirstName} ${user.LastName}`}
                </MenuItem>
              ))}
          </TextField>
        </Collapse>
      </Grid>

      <Grid item xs={4}>
        <Collapse in={idNotaryUser > 0}>
          <CustomeTextField
            attr='idFederalStateLogin'
            label='Zugang'
            object={payload}
            setObject={setPayload}
            type='select'
            null={payload.idFederalStateLogin === null}
          >
            {(federalStateLogins || [])
              .filter(login => login.isFirstStage == false)
              .filter(login => login.idFederalState === idFedearalState)
              .filter(login => login.Notary_idUser === idNotaryUser)
              .map(login => (
                <MenuItem
                  key={`idFederalStateLogin-${login.idFederalStateLogin}`}
                  value={login.idFederalStateLogin}
                >
                  {login.Username} // {login.SecondName}
                </MenuItem>
              ))}
          </CustomeTextField>
        </Collapse>
      </Grid>

      <Grid item xs={6}>
        <CustomeTextField
          label='Gericht'
          attr='idDistrictCourt'
          object={payload}
          setObject={(updatedPayload: IPayload) => {
            const testDistrictObject = districtCourtArray.find(
              x => x.idDistrictCourt === updatedPayload.idDistrictCourt
            );
            if (testDistrictObject !== undefined) {
              setPayload({
                ...payload,
                idDistrictCourt: updatedPayload.idDistrictCourt,
                Court: testDistrictObject.Court,
              });
            } else if (payload.idDistrictCourt === null) {
              setPayload({
                ...payload,
                idDistrictCourt: null,
                Court: '',
              });
            }
          }}
          type='select'
          null
          required
        >
          {districtCourtArray.map(x => (
            <MenuItem
              key={`court-${x.idDistrictCourt}`}
              value={x.idDistrictCourt}
            >
              {x.Court}
            </MenuItem>
          ))}
        </CustomeTextField>
      </Grid>

      <Grid item xs={5}>
        <CustomeTextField
          label='Gemarkung'
          attr='idLandMarking'
          object={payload}
          required
          setObject={(updatedPayload: IPayload) => {
            const testLandMarking = landMarkingArray.find(
              x => x.idLandMarking === updatedPayload.idLandMarking
            );
            if (testLandMarking !== undefined) {
              const testDistrictObject = districtCourtArray.find(
                x => x.idDistrictCourt === testLandMarking?.idDistrictCourt
              );
              if (testDistrictObject !== undefined) {
                setPayload({
                  ...payload,
                  idDistrictCourt: testDistrictObject.idDistrictCourt,
                  Court: testDistrictObject.Court,
                  idLandMarking: testLandMarking.idLandMarking,
                  Marking: testLandMarking.LandMarking,
                });
              }
            } else if (updatedPayload.idLandMarking === null) {
              setPayload({
                ...payload,
                idLandMarking: null,
                Marking: '',
              });
            }
          }}
          type='select'
          null
        >
          {landMarkingArray
            .filter(
              x =>
                payload.idDistrictCourt === null ||
                x.idDistrictCourt === payload.idDistrictCourt
            )
            .sort((a, b) => (a.LandMarking > b.LandMarking ? 1 : -1))
            .map(x => (
              <MenuItem
                key={`landmarking-${x.idLandMarking}`}
                value={x.idLandMarking}
              >
                {x.LandMarking}{' '}
                {payload.idDistrictCourt === null && (
                  <>
                    {' '}
                    (
                    {
                      districtCourtArray.find(
                        y => y.idDistrictCourt === x.idDistrictCourt
                      )?.Court
                    }
                    )
                  </>
                )}
              </MenuItem>
            ))}
        </CustomeTextField>
      </Grid>

      <Grid item sm={12}>
        <ChangeLegalPhaseCondition
          idLegalTransaction={idLegalTransaction}
          legalTransaction_has_LegalTransactionSpecialFunctionArray={
            legalTransaction_has_LegalTransactionSpecialFunctionArray
          }
          setLegalTransaction_has_LegalTransactionSpecialFunctionArray={
            setLegalTransaction_has_LegalTransactionSpecialFunctionArray
          }
          legalPhaseFullObjectArray={legalPhaseFullObjectArray}
          legalReqState={legalReqState}
          specialFunction={currentSpecialFunction}
        />
      </Grid>
    </React.Fragment>
  );
};
